module.exports = __webpack_public_path__ + "static/media/bank-api-logo.795ab9c2.svg";